import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("slideShowCard", component(opts));
  editor.BlockManager.add("slideShowCard", block(opts));
};